import { render, staticRenderFns } from "./SupportChatWidget.vue?vue&type=template&id=69d6a2bc&scoped=true&lang=pug"
import script from "./SupportChatWidget.vue?vue&type=script&lang=js"
export * from "./SupportChatWidget.vue?vue&type=script&lang=js"
import style0 from "./SupportChatWidget.vue?vue&type=style&index=0&id=69d6a2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d6a2bc",
  null
  
)

export default component.exports